import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-purchase-order-modal",
  templateUrl: "./purchase-order-modal.component.html",
  styleUrls: ["./purchase-order-modal.component.sass"],
})
export class PurchaseOrderModalComponent implements OnInit {
  item: any;
  APIEndpoint = environment.APIEndpoint;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit() {
    // Initialize item first
    this.item = this.item || {};

    // Format the date
    if (this.item.createdAt) {
      this.item.createdAt = new Date(this.item.createdAt).toLocaleDateString("en-GB");
    }

    // Initialize inventory
    this.item.inventory = this.item.inventory || {};

    // Handle notes correctly - use inventoriesNote instead of note
    this.item.note = this.item.inventoriesNote || [];

    console.log(this.item, "inside modal");
  }

  handleCloseModal() {
    this.bsModalRef.hide();
  }
}